import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 21 21",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="m16.841 9.792-1.32-4.625a1.667 1.667 0 0 0-1.603-1.209H7.682c-.744 0-1.398.494-1.603 1.21L4.76 9.791m4.552.516c-.215-.28-.517-.515-.87-.515H4.758v4.583c0 .92.746 1.667 1.667 1.667h8.75c.92 0 1.666-.747 1.666-1.667V9.792h-3.684c-.353 0-.654.235-.869.515a1.872 1.872 0 0 1-2.976 0Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);